(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact_our_platform"] && !Shopify.designMode) return;
  try {
    
  $(function(){

    //打开环信客服
    let huanxin_customer_service = function(){
      window.easemobim = window.easemobim || {};
      easemobim.config = {
        hide: true,
        autoConnect: false,
        configId: '5c8b614f-8d90-4060-88f1-673d508301d5',
        //打开
        onopen: function () {},
        //收起
        onclose: function () {},
      }
      easemobim.bind({configId: "5c8b614f-8d90-4060-88f1-673d508301d5"})
    }

    $('.Email_Us').on('click', function () {
      console.log(1)
      var el = document.createElement("a");
			document.body.appendChild(el);
			el.href = "mailto:info@tozostore.com";
			el.click();
			document.body.removeChild(el);
    })
    $('.Social_media').on('click', function () {
      console.log(2)
    })
    $('.Live_Chat').on('click', function () {
      console.log(3)
      huanxin_customer_service()
    })
    $('.Call_Us').on('click', function () {
      console.log(4)
    })

    

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distributor"] && !Shopify.designMode) return;
  try {
    

  var api_url = 'https://api.tozostore.com/api/v1/'
  console.log(api_url)
  var country_id
  var country_iso_code

  /*const productUpload = document.getElementById('productUpload');*/
  const imgContainer_1 = document.getElementById('imgContainer_1');
  const img_1 = document.getElementById('img_1');
  const icon_1 = document.getElementById('icon_1');
  const img_box_1 = document.getElementById('img_box_1');
  const img_mask1 = document.getElementById('img-mask1');

  const imgContainer_2 = document.getElementById('imgContainer_2');
  const img_2 = document.getElementById('img_2');
  const icon_2 = document.getElementById('icon_2');
  const img_mask2 = document.getElementById('img-mask2');

  const imgContainer_3 = document.getElementById('imgContainer_3');
  const img_3 = document.getElementById('img_3');
  const icon_3 = document.getElementById('icon_3');
  const img_mask3 = document.getElementById('img-mask3');

  const showImg_1 = document.getElementById('showImg_1');
  const delImg_1 = document.getElementById('delImg_1');

  const showImg_2 = document.getElementById('showImg_2');
  const delImg_2 = document.getElementById('delImg_2');

  const showImg_3 = document.getElementById('showImg_3');
  const delImg_3 = document.getElementById('delImg_3');

  const modal = document.getElementById('modal');
  const modalImg = document.getElementById('modalImg');
  const closeIcon = document.getElementById('closeIcon');

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  const Sava_text = document.getElementById('Sava_text');
  const Sava_img = document.getElementById('Sava_img');
  var NextButton = true;
  var SavaButton = true;


  modal.style.width = '0%';
  modal.style.height = '0%';

  let imgUrl_1 = '';
  let imgUrl_2 = '';
  let imgUrl_3 = '';

  let uploadData = {
    id: localStorage.getItem('coop_distributor_id'),
    busi: [],
    comp: [],
    prod: []
  }

  // 点击预览图片1
  showImg_1.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_1;
  }
  // 点击预览图片2
  showImg_2.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_2;
  }
  // 点击预览图片3
  showImg_3.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_3;
  }

  // 关闭 modal 框
  closeIcon.onclick = function (value) {
    modal.style.width = '0';
    modal.style.height = '0';
    modalImg.src = '';
  }

  // 删除上传的图片1
  delImg_1.onclick = function (value) {
    businessUpload.value = '';
    imgUrl_1 = '';
    icon_1.style.display = 'block';
    imgContainer_1.style.display = 'none';
    uploadData.busi = []
  }
  // 删除上传的图片2
  delImg_2.onclick = function (value) {
    companyUpload.value = '';
    imgUrl_2 = '';
    icon_2.style.display = 'block';
    imgContainer_2.style.display = 'none';
    uploadData.comp = []
  }
  // 删除上传的图片3
  delImg_3.onclick = function (value) {
    productUpload.value = '';
    imgUrl_3 = '';
    icon_3.style.display = 'block';
    imgContainer_3.style.display = 'none';
    uploadData.prod = []
  }

  $(document).ready(function() {
    const dropdown = document.querySelector('.dropdown')
    const input__icon_country = document.querySelector('.input__icon_country')
    const input__icon = document.querySelector('.input__icon')
    const dropdownText_country = document.querySelector('#country')
    const dropdownText = document.querySelector('#prefix')
    const dropdownMenu_country = document.querySelector('.dropdown-menu_country')
    const dropdownMenu = document.querySelector('.dropdown-menu')
    const dropdownIcon_country = document.querySelector('.input__icon-arrow_country')
    const dropdownIcon = document.querySelector('.input__icon-arrow')
    const phoneGet = document.querySelector('.phone__get')
    const phoneNumber = document.querySelector('#phone')
    const isacc = document.querySelector('#isacc')
    const businessUpload = document.querySelector('#businessUpload')
    const companyUpload = document.querySelector('#companyUpload')
    const productUpload = document.querySelector('#productUpload')
    const sava_submit = document.querySelector('#Sava_submit')
    
    input__icon_country.addEventListener('click', function() {
      get_country_list()
    })
    dropdownText_country.addEventListener('click', function() {
      get_country_list()
    })

    input__icon.addEventListener('click', function() {
      get_code_list()
    })
    dropdownText.addEventListener('click', function() {
      get_code_list()
    })
    function get_country_list(){
      if(dropdownMenu_country.style.display == 'none') {
        dropdownMenu_country.style.display = 'block'
        dropdownIcon_country.classList.add('is__reverse')
      }else {
        dropdownMenu_country.style.display = 'none'
        dropdownIcon_country.classList.remove('is__reverse')
      }
    }

    function get_code_list(){
      if(dropdownMenu.style.display == 'none') {
        dropdownMenu.style.display = 'block'
        dropdownIcon.classList.add('is__reverse')
      }else {
        dropdownMenu.style.display = 'none'
        dropdownIcon.classList.remove('is__reverse')
      }
    }

    let flag = true
    phoneGet.addEventListener('click',function() {

      if(!phoneNumber.value){
        error_fun('phone_required', 'error_text')
        return
      }else{
        error_fun('', 'error_text')
      }

      let data = {
        phone: phoneNumber.value,
        prefix: dropdownText.value.slice(1)
      }
      if(flag) {
        flag = false
        $.ajax({
        url: api_url + 'sms',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          if(res.code == 1){
            // form.reset();
            phoneGet.classList.add('cursor_no')
            let time = 60
            let countdownInterval = setInterval(() => {
              if(time <= 0) {
                clearInterval(countdownInterval)
                phoneGet.classList.remove('cursor_no')
                let textContent = get_code_text()
                phoneGet.textContent = textContent ? textContent : 'Get Code'
                time = 60
                flag = true
              } else {
                time--
                phoneGet.textContent = time + 's'
              }
            }, 1000);
          }else{
            flag = true
            error_fun(res, 'error_fun')
          }
        },
        error: function(xhr, status, error) {
          flag = true
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
      }
    })

    function removeClass(elms,targetElm) {
      elms.forEach((item) => {
        item.classList.remove(targetElm)
      })
    }

    $.ajax({
      url: api_url + 'country?lang_id=1',
      type: 'get',
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function(res) {
        console.log(res)
        if(res.code == 1){
          // form.reset();
          let data = res.data
          dropdownText.value = `+${data[0].call_prefix}`
          dropdownText_country.value = `${data[0].name}`
          for (let i = 0; i < data.length; i++) {
            const li = document.createElement("li")
            li.innerHTML =  `
              <span class="ls-select__option-prefix">+${data[i].call_prefix}</span>
              <span class="ls-select__option-code">${data[i].iso_code}</span>
            `
            if(i === 0) {
              li.classList.add('select_li')
            }
            li.addEventListener('click', function() {
              dropdownText.value = `+${data[i].call_prefix}`
              dropdownMenu.style.display = 'none'
              dropdownIcon.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu >li')
              removeClass(prefixs,'select_li')
              li.classList.add('select_li')
            })
            dropdownMenu.appendChild(li)


            const div = document.createElement("div")
            div.innerHTML = `<span class="ls-select__option-prefix">${data[i].name}</span>`
            if(i === 0) {
              div.classList.add('select_li')
            }
            div.addEventListener('click', function() {
              dropdownText.value = `+${data[i].call_prefix}`
              country_id = `${data[i].id}`
              country_iso_code = `${data[i].iso_code}`

              dropdownText_country.value = `${data[i].name}`
              dropdownMenu_country.style.display = 'none'
              dropdownIcon_country.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu_country > div')
              removeClass(prefixs,'select_li')
              div.classList.add('select_li')
            })
            dropdownMenu_country.appendChild(div)
          }
          }else{
            error_fun(res, 'error_fun')
          }
      },
      error: function(xhr, status, error) {
        error_fun(error, 'error_fun')
        // form.reset();
      }
    })

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
      
      if(button == 'Sava'){
        if(type == 'text'){
          SavaButton = true
          Sava_text.style.display = 'block'
          Sava_img.style.display = 'none'
        }else{
          SavaButton = false
          Sava_text.style.display = 'none'
          Sava_img.style.display = 'block'
        }
      }
    }

    function showMessage(type, message, duration = 3000) {
      // const messageBox = document.getElementById('message');
      // messageBox.style.transform = 'translate(-50%,0)'
      // const html = `<span>${message}</span>`;
      // messageBox.innerHTML = html;
      // messageBox.classList.add(type, 'show');
      // setTimeout(() => {
      // messageBox.classList.remove(type,'show');
      // messageBox.style.transform = 'translate(-50%, 50px)'
      // }, duration);
    }

    businessUpload.addEventListener('change',function(value) {
      get_coop_distributor_id(1, businessUpload)
    })

    companyUpload.addEventListener('change',function(value) {
      get_coop_distributor_id(2, companyUpload)
    })

    productUpload.addEventListener('change',function(value) {
      /*const fileList = value.target.files;*/
      get_coop_distributor_id(3, productUpload)
    })

    function get_coop_distributor_id(num, Upload){
      let coop_distributor_id = localStorage.getItem('coop_distributor_id')
      if(!coop_distributor_id || coop_distributor_id == null) {
        img_fun_err(0, "js_image_required")
        // img_fun_err(0, "{{ 'distributor_page.js_image_required' | t: option: option.name }}")
        // showMessage('error', "{{ 'distributor_page.js_complete_first_step' | t: option: option.name }}")
        return
      }
      get_imgList(num, Upload)
      // post_img_pai(num, Upload) 
    }

    function get_imgList(type, Upload_list){
      const fileList = Upload_list.files
      let file_type = fileList[0].type
      if (fileList.length) {
        const index = file_type.lastIndexOf("/");
        const pathType = file_type.slice(index + 1, file_type.length);
        console.log(pathType)
        // if(fileList[0].type == "application/pdf"){
        //   // get_pdfList(type, fileList)
        //   // img_box_1.style.display = 'none'
        // }else 
        if(fileList[0].size > 1024 * 1024 * 3){
          console.log('文件总大小不能超过3M')
          img_fun_err(type, "js_image_file_max")
          // img_fun_err(type, "{{ 'distributor_page.js_image_file_max' | t: option: option.name }}")
        }else if(pathType == "jpg" || pathType == "jpeg" || pathType == "png" || pathType == "bmp"){
          post_img_pai(type, Upload_list) 
          let gif_url = 'https://cdn.shopifycdn.net/s/files/1/0737/0578/3585/files/98288-loading.gif?v=1686638388'
          if(type == 1){
            imgContainer_1.style.display = 'block';
            icon_1.style.display = 'none';
            img_mask1.style.display = 'none';
            img_1.src = gif_url;
          }else if(type == 2){
            imgContainer_2.style.display = 'block';
            icon_2.style.display = 'none';
            img_mask2.style.display = 'none';
            img_2.src = gif_url;
          }else if(type == 3){
            imgContainer_3.style.display = 'block';
            icon_3.style.display = 'none';
            img_mask3.style.display = 'none';
            img_3.src = gif_url;
          }
          // if(type == 1){
          //   imgContainer_1.style.display = 'block';
          //   icon_1.style.display = 'none';
          //   imgUrl_1 = window.URL.createObjectURL(fileList[0]);
          //   img_1.src = imgUrl_1;
          //   console.log(imgUrl_1)
          //   console.log(img_1)
          //   img_fun_err(type, '')
          // }else if(type == 2){
          //   imgContainer_2.style.display = 'block';
          //   icon_2.style.display = 'none';
          //   imgUrl_2 = window.URL.createObjectURL(fileList[0]);
          //   img_2.src = imgUrl_2;
          //   console.log(imgUrl_2)
          //   console.log(img_2)
          //   img_fun_err(type, '')
          // }else if(type == 3){
          //   imgContainer_3.style.display = 'block';
          //   icon_3.style.display = 'none';
          //   imgUrl_3 = window.URL.createObjectURL(fileList[0]);
          //   img_3.src = imgUrl_3;
          //   console.log(imgUrl_3)
          //   console.log(img_3)
          //   img_fun_err(type, '')
          // }
        }else{
          console.log('文件类型不支持')
          img_fun_err(type, "js_image_file_type")
          // img_fun_err(type, "{{ 'distributor_page.js_image_file_type' | t: option: option.name }}")
        }
      }
    }

    function get_pdfList(type, fileList){
      const file = fileList;
      const fileReader = new FileReader();
      console.log(fileReader)
      fileReader.onload = function() {
        const typedArray = new Uint8Array(this.result);
        PDFJS.getDocument(typedArray).then(function(pdf) {
          pdf.getPage(1).then(function(page) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const viewport = page.getViewport({ scale: 1 });
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            page.render({ canvasContext: context, viewport: viewport }).promise.then(function() {
              pdfViewer.appendChild(canvas);
            });
          });
        });
      };
      console.log(fileReader)
      fileReader.readAsArrayBuffer(file);
    }

    function post_img_pai(type, Upload_type){
      let coop_distributor_id = localStorage.getItem('coop_distributor_id')
      console.log(coop_distributor_id)
      if(!coop_distributor_id || coop_distributor_id == null) {
        error_fun('js_complete_first_step', 'error_text')
        // showMessage('error', "{{ 'distributor_page.js_complete_first_step' | t: option: option.name }}")
        // api_err.innerHTML = "{{ 'distributor_page.js_complete_first_step' | t: option: option.name }}"
        return 
      }
      const formData = new FormData()
      formData.append('coop_distributor_id', coop_distributor_id)
      formData.append('type', type)
      formData.append('file', Upload_type.files[0])
      // 打印参数
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      if(Upload_type.files.length > 0) {
          $.ajax({
            url: api_url + 'coop/distributor/file',
            type: 'post',
            data:formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function(res) {
              if(res.code == 1){
                const fileList = Upload_type.files
                if(type == 1){
                  uploadData.busi.push(res.data.id)
                  imgContainer_1.style.display = 'block';
                  icon_1.style.display = 'none';
                  img_mask1.style.display = 'block';
                  imgUrl_1 = window.URL.createObjectURL(fileList[0]);
                  img_1.src = imgUrl_1;
                  img_fun_err(type, '')
                }else if(type == 2){
                  uploadData.comp.push(res.data.id)
                  imgContainer_2.style.display = 'block';
                  icon_2.style.display = 'none';
                  img_mask2.style.display = 'block';
                  imgUrl_2 = window.URL.createObjectURL(fileList[0]);
                  img_2.src = imgUrl_2;
                  img_fun_err(type, '')
                }else if(type == 3){
                  uploadData.prod.push(res.data.id)
                  imgContainer_3.style.display = 'block';
                  icon_3.style.display = 'none';
                  img_mask3.style.display = 'block';
                  imgUrl_3 = window.URL.createObjectURL(fileList[0]);
                  img_3.src = imgUrl_3;
                  img_fun_err(type, '')
                }
                // if(type == 1){
                //   uploadData.busi.push(res.data.id)
                // }else if(type == 2){
                //   uploadData.comp.push(res.data.id)
                // }else if(type == 3){
                //   uploadData.prod.push(res.data.id)
                // }
              }else{
                error_fun(res, 'error_fun')
              }
            },
            error: function(xhr, status, error) {
              form_loding('Sava', 'text')
              error_fun(error, 'error_fun')
              // form.reset();
            }
          })
      }
    }

    $('#suppiler-form1')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this)
      let prefix = dropdownText.value.slice(1)
      let isaccValue = isacc.checked
      formData.set('prefix', prefix)
      formData.set('isacc', isaccValue)

      // 打印参数
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'coop/distributor',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 1){
            click_set_fun(2)
            localStorage.setItem('coop_distributor_id', res.data.id)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

    sava_submit.addEventListener('click', function(event) {
      event.preventDefault();
      console.log(uploadData.busi)
      console.log(uploadData.comp)
      console.log(uploadData.prod)
      if(uploadData.busi.length == 0){
        return img_fun_err(1, "js_image_business_license")
        // return img_fun_err(1, `{{ 'distributor_page.js_image_business_license' | t: option: option.name }}`)
      }else if(uploadData.comp.length == 0){
        return img_fun_err(2, "js_image_qualification_image")
        // return img_fun_err(2, `{{ 'distributor_page.js_image_qualification_image' | t: option: option.name }}`)
      }else if(uploadData.prod.length == 0){
        return img_fun_err(3, "js_image_manual_images")
        // return img_fun_err(3, `{{ 'distributor_page.js_image_manual_images' | t: option: option.name }}`)
      }else{
        img_fun_err(0, '')
      }
      put_manufacturer()
    })
    
    function put_manufacturer(){
      console.log(SavaButton)
      if(!SavaButton){ return }
      form_loding('Sava', 'img')
      api_err.innerHTML = ''
      uploadData.id = localStorage.getItem('coop_distributor_id')
      $.ajax({
        url: api_url + 'coop/distributor',
        type: 'put',
        data: uploadData,
        success: function(res) {
          console.log(uploadData)
          form_loding('Sava', 'text')
          if(res.code == 1){
            click_set_fun(3)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edm_subscription"] && !Shopify.designMode) return;
  try {
    
  // var api_url = 'https://api.tozostore.com/api/v1/' //业务 生产
  var api_url = 'https://api-user.tozostore.com/api/' //用户 生产
  //var api_url = 'https://api-user.tozo.tech/api/' //用户 测试
  
  console.log(api_url)
  const Submit_text = document.getElementById('Submit_text');
  const Next_img = document.getElementById('Next_img');
  var api_err = document.getElementById('api_err');
  var SubmitButton = true

  $(document).ready(function() {
    const phoneGet = document.querySelector('.phone__get')
    const email = document.querySelector('#email')
    const code = document.querySelector('#code')

    //邮箱失去焦点处理
    email.addEventListener("blur", function() {
      // 处理失去焦点事件的逻辑
      emailEer.textContent = setCustomValidity_email()
    });

    //验证码失去焦点处理
    code.addEventListener("blur", function() {
      // 处理失去焦点事件的逻辑
      if(!code.value){
        codeEer.textContent = 'please enter verification code'
        return codeEer.textContent
      }else{
        codeEer.textContent = ''
        return codeEer.textContent
      }
    });

    //获取验证码
    let flag = true
    phoneGet.addEventListener('click',function() {
      console.log(email.value)
      emailEer.textContent = setCustomValidity_email()
      if(emailEer.textContent != ''){
        return
      }
      let data = {
        email: email.value,
      }
      if(flag) {
        flag = false
        $.ajax({
        url: api_url + 'center/subscribeemailCode',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          if(res.code == 0){
            // form.reset();
            phoneGet.classList.add('cursor_no')
            let time = 60
            let countdownInterval = setInterval(() => {
              if(time <= 0) {
                clearInterval(countdownInterval)
                phoneGet.classList.remove('cursor_no')
                phoneGet.textContent = 'Get code'
                time = 60
                flag = true
              } else {
                time--
                phoneGet.textContent = time + 's'
              }
            }, 1000);
          }else{
            error_fun(res)
          }
        },
        error: function(xhr, status, error) {
          error_fun(error)
          // form.reset();
        }
      })
      }
    })

    //删除
    function removeClass(elms,targetElm) {
      elms.forEach((item) => {
        item.classList.remove(targetElm)
      })
    }

    //提交
    $('#EDM-form')[0].addEventListener('submit', function(event) {
      console.log('event')
      console.log(event)
      event.preventDefault();
      api_err.innerHTML = '' //每次请求先清空上一次的错误提示
      if(setDivCheckbox() != ''){
        return
      }
      console.log(this)
      var formData = new FormData(this)
      // console.log(typeof FormData); //如果控制台输出 function，则表示浏览器支持 FormData 对象。如果输出 undefined，则表示浏览器不支持 FormData 对象。

      console.log(document.getElementById('is_online1').checked)
      console.log(document.getElementById('is_online2').checked)
      if(!isOnline){
        if(document.getElementById('is_online1').checked == true){
          isOnline = 1
          console.log('isOnline1')
        }else{
          isOnline = 2
          console.log('isOnline2')
        }
      }

      // 取消订阅时收集原因
      if(isOnline == 2){
        if(selectedOptions && selectedOptions.length != 0){
            selectedOptions.forEach((item, index) => {
              formData.append(`reasons[${index}]`, item);
          })
        }
      }

      formData.append("status", isOnline);
      formData.delete("is_online");//不传is_online的参数

      // email: email.value,
      // status: email.value,
      // code: email.code,
      // reasons: email.value,

      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }
      console.log(SubmitButton)
      if(!SubmitButton){ return }
      form_loding('Next', 'img')
      $.ajax({
        url: api_url + 'center/subscribe',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 0){
            emptyInputFun() //清空输入框
            click_set_fun(2)
          }else{
            error_fun(res)
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error)
          // form.reset();
        }
      })
    })
    
    //提交按钮的loding
    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          SubmitButton = true
          Submit_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          SubmitButton = false
          Submit_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
    }
    
    //错误提示
    function error_fun(data){
      console.log('error_fun',  data)
      console.log('error_fun_code',  data.code)
      if(data.code == 0){
        api_err.innerHTML = ''
      }else if(data.code == 4006){  
        api_err.innerHTML = 'The email verification code does not match.'
      }else if(data.code == 5000){
        api_err.innerHTML = 'System error'
      }else if(data.status == 200){
        if(data.responseJSON.code != 0){
          api_err.innerHTML = data.responseJSON.message
        }else{
          api_err.innerHTML = 'System error'
        }
      }else if(data.status == 500){
        if(data.responseJSON.code == 2){
          api_err.innerHTML = 'Please check if the information entered is correct'
        }else{
          api_err.innerHTML = 'System error'
        }
      }else if(data.status == 403 || data.status == 422){
        if(data.responseJSON.code == 2){
          api_err.innerHTML = data.responseJSON.message
        }else{
          api_err.innerHTML = 'System error'
        }
      }else{
        api_err.innerHTML = 'System error'
      }
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["historical_event"] && !Shopify.designMode) return;
  try {
    
  $(function(){
    // 时间轴
    var timerNum = 0;
    var width = $('.timer-scale-cont')[0].offsetWidth;
    var space = width + 20; // 移动间距
    var length = $('.timer-scale-cont').length, numL;
    
    var scaleHeight = $('.timer-scale')[0].offsetHeight;
    let timer_shaft = document.getElementById("timer-shaft")


    // 绑定点击事件
    let Show_more_text = document.getElementById("Show_more_text")
    // 设置初始状态为收缩
    var isExpanded = true;
    set_height()
    Show_more_text.addEventListener('click', function() {
      set_height()
    });
    
    function set_height(){
      // 切换展开收缩状态
      isExpanded = !isExpanded;
      // 根据状态设置内容的高度和按钮的文本
      if (isExpanded) {
        timer_shaft.style.height = scaleHeight + 'px'
        Show_more_text.innerHTML = get_btn_text('Pack_Up')
        timer_shaft.style.transition = 'height 0.5s ease 0s';
      } else {
        timer_shaft.style.height = 400 + 'px'
        Show_more_text.innerHTML = get_btn_text('Show_More')
        timer_shaft.style.transition = 'height 0.5s ease 0s';
      }
    }

    // 向上取整,有小数就整数部分加1
    let remainder = Math.ceil(window.screen.width/width)
    numL = remainder-1
    // 分辨率
    if(window.screen.width > 1280) {
      // numL = length - 4
      numL = length - 3
    } else if(window.screen.width < 1200 && window.screen.width > 769) {
      // numL = length - 5
      numL = length - 2
    } else if(window.screen.width < 769 && window.screen.width > 500) {
      // numL = length - 6
      numL = length - 1
    } else if(window.screen.width < 500) {
      // numL = length - 7
      numL = length
    }
    
    // 左滑
    var let_sliding = function(){
      if(timerNum > 0) {
        timerNum -= 1;
        moveL(timerNum, numL)
      }
      tags(timerNum);
    }
    // 右滑
    var right_sliding = function(){
      if(timerNum < length - 1) {
        timerNum += 1;
        tags(timerNum);
      }
      moveL(timerNum, numL)
    }
    // 定时事件
    var time_fun = function(){
      if(timerNum == length - 1){
        timerNum = 0;
        tags(timerNum);
      }else{
        if(timerNum < length - 1) {
          timerNum += 1;
          tags(timerNum);
        }
      }
      moveL(timerNum, numL)
    }
    //定时器
    let time_num = 3000
    var time = setInterval(time_fun, time_num) //time_fun是你的函数
    
    var a1,a2
    let slide_fun = function(){
      clearInterval(time)//清除定时器
      if(a1>a2){
        // let_sliding()
        console.log("左滑啊")
      }
      if(a1<a2){
        right_sliding()
        console.log("右滑啊")
      }
      setTimeout(()=>{
        time = setInterval(time_fun, time_num)//重新开始定时器
      },3000)
    }


    // 鼠标移入容器内停止自动
    $(".timer-shaft-box").mouseover(function(){
      clearInterval(time)//清除定时器
    }).mouseout(function(){
      time = setInterval(time_fun, time_num)//重新开始定时器
    }).mousedown(function(e){
      a1=e.screenX;
      // slide_fun()
    }).mouseup(function(e){
      a2=e.screenX;
      // slide_fun()
    });
    
    // 点击选中事件
    var click_fun = function(that,index){
      $(that).on('click', function () {
        timerNum = index;
        moveL(timerNum, numL)
        tags(timerNum);
      })
    }
    
    // 点击左侧
    $('.timer-left').on('click', function () {
      let_sliding()
    })
    // 点击右侧
    $('.timer-right').on('click', function () {
      right_sliding()
    })
    // 点击年
    $('.time-circle').each(function (index) {
      let that = this
      click_fun(that,index)
    })
    // 盒子
    $('.timer-scale-cont').each(function (index) {
      let that = this
      click_fun(that,index)
    })
    
    function tags(num){
      $('.timer-scale-cont').eq(num).addClass('hov').siblings().removeClass('hov');
      $('.shaft-detail-cont').eq(num).show().siblings().hide();
    }
    function moveL(num, len) {
      if (num < len) {
        moveLeft = -num * space;
        $('.timer-scale').animate({left:moveLeft}, 700);
      }
    }
    
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__contact-form-jp"] && !Shopify.designMode) return;
  try {
    
const fileInput = $('#fileInput')
const fileText = $('.text')
const form = $('#my-form')[0]


  const contact_form_loading_text = document.getElementById('loading_text');
  const contact_form_loading_img = document.getElementById('loading_img');
  function maintenance_form_loding(button, type){
    if(button == 'Next'){
      if(type == 'text'){
        contact_form_loading_text.style.display = 'block'; 
        contact_form_loading_img.style.display = 'none';
      }else{
        contact_form_loading_text.style.display = 'none'; 
        contact_form_loading_img.style.display = 'block';
      }
    }
  }

fileInput[0]?.addEventListener('change', function() {
  const curFiles = fileInput[0].files
  let file = curFiles[0]
  if(curFiles.length > 0) {
    var fileSize = file.size
    var size = fileSize / 1024
    if (size > 10000) {
      showMessage('warning','Attachments must not be larger than 10M')
      return
    }
    const types = ['application/rtf', 'text/rtf', 'application/msword', 'application/pdf', 'application/x-rar-compressed', 'application/zip', 'image/png', 'image/jpeg', 'image/gif']
    if (file.type && types.indexOf(file.type) === -1) {
      showMessage('error','File type error')
      return
    } else {
      const arr = file.name.match(/\.([a-zA-Z]+)$/)
      if (arr) {
        const ext = arr[1]
        const extArr = ['rtf', 'doc', 'pdf', 'zip', 'rar', 'png', 'jpeg', 'jpg', 'gif']
        if (extArr.indexOf(ext) === -1) {
          showMessage('error','File type error')
          return 
        }
      }
    }
    fileText[0].setAttribute("placeholder",curFiles[0].name);
  }
})

function showMessage(type, message, duration = 5000) {
  const messageBox = document.getElementById('message');
  console.log(messageBox)
  messageBox.style.transform = 'translate(-50%,200px)'
  const html = `<span>${message}</span>`;
  messageBox.innerHTML = html;
  messageBox.classList.add(type, 'show');
  setTimeout(() => {
    messageBox.classList.remove(type,'show');
    messageBox.style.transform = 'translate(-50%, 300px)'
  }, duration);
}

form.addEventListener('submit', function(event) {
  event.preventDefault()
  let formData = new FormData()
  const name = document.querySelectorAll('#textfield')[0]?.value || ''
  const selectElm = $('#select')[0]
  const selectVal = selectElm ? selectElm.options[selectElm.selectedIndex].value : ''
  const order = document.querySelectorAll('#textfield')[1]?.value || ''
  let file = fileInput[0]?.files[0] || ''
  const email = $('#email')[0]?.value || ''
  const desc = $('#textarea')[0]?.value || ''
  formData.append('email',email)
  formData.append('description', desc)

  formData.append('name',name)
  formData.append('product_name',selectVal)
  formData.append('order_id',order)
  if(file) formData.append('file',file)

  maintenance_form_loding('Next', 'loading')
  
  setTimeout(()=>{
    maintenance_form_loding('Next', 'text')
    showMessage('success','送信成功')
    fileText[0]?.setAttribute("placeholder",'rtf, doc, pdf, zip, rar, png, jpeg, jpg, gif');
    form.reset();
  }, 1000)

  // $.ajax({
  //   // url: 'https://api.tozo.tech/api/v1/contactform',
  //   url: 'https://api.tozostore.com/api/v1/contactform',
  //   type: 'post',
  //   data:formData,
  //   processData: false,
  //   contentType: false,
  //   dataType: 'json',
  //   success: function(data) {
  //     maintenance_form_loding('Next', 'text')
  //     console.log(data)
  //     showMessage('success',data.message)
  //     fileText[0]?.setAttribute("placeholder",'rtf, doc, pdf, zip, rar, png, jpeg, jpg, gif');
  //     form.reset();
  //   },
  //   error: function(xhr, status, error) {
  //     maintenance_form_loding('Next', 'text')
  //     showMessage('error', 'Failed to submit warranty data, please try later');
  //     fileText[0]?.setAttribute("placeholder",'rtf, doc, pdf, zip, rar, png, jpeg, jpg, gif');
  //     // form.reset();
  //   }
  // })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__contact-form"] && !Shopify.designMode) return;
  try {
    
const fileInput = $('#fileInput')
const fileText = $('.text')
const form = $('#my-form')[0]


  const contact_form_loading_text = document.getElementById('loading_text');
  const contact_form_loading_img = document.getElementById('loading_img');
  function maintenance_form_loding(button, type){
    if(button == 'Next'){
      if(type == 'text'){
        contact_form_loading_text.style.display = 'block'; 
        contact_form_loading_img.style.display = 'none';
      }else{
        contact_form_loading_text.style.display = 'none'; 
        contact_form_loading_img.style.display = 'block';
      }
    }
  }

fileInput[0]?.addEventListener('change', function() {
  const curFiles = fileInput[0].files
  let file = curFiles[0]
  if(curFiles.length > 0) {
    var fileSize = file.size
    var size = fileSize / 1024
    if (size > 10000) {
      showMessage('warning','Attachments must not be larger than 10M')
      return
    }
    const types = ['application/rtf', 'text/rtf', 'application/msword', 'application/pdf', 'application/x-rar-compressed', 'application/zip', 'image/png', 'image/jpeg', 'image/gif']
    if (file.type && types.indexOf(file.type) === -1) {
      showMessage('error','File type error')
      return
    } else {
      const arr = file.name.match(/\.([a-zA-Z]+)$/)
      if (arr) {
        const ext = arr[1]
        const extArr = ['rtf', 'doc', 'pdf', 'zip', 'rar', 'png', 'jpeg', 'jpg', 'gif']
        if (extArr.indexOf(ext) === -1) {
          showMessage('error','File type error')
          return 
        }
      }
    }
    fileText[0].setAttribute("placeholder",curFiles[0].name);
  }
})

function showMessage(type, message, duration = 5000) {
  const messageBox = document.getElementById('message');
  console.log(messageBox)
  messageBox.style.transform = 'translate(-50%,200px)'
  const html = `<span>${message}</span>`;
  messageBox.innerHTML = html;
  messageBox.classList.add(type, 'show');
  setTimeout(() => {
    messageBox.classList.remove(type,'show');
    messageBox.style.transform = 'translate(-50%, 300px)'
  }, duration);
}

form.addEventListener('submit', function(event) {
  event.preventDefault()
  let formData = new FormData()
  const name = document.querySelectorAll('#textfield')[0]?.value || ''
  const selectElm = $('#select')[0]
  const selectVal = selectElm ? selectElm.options[selectElm.selectedIndex].value : ''
  const order = document.querySelectorAll('#textfield')[1]?.value || ''
  let file = fileInput[0]?.files[0] || ''
  const email = $('#email')[0]?.value || ''
  const desc = $('#textarea')[0]?.value || ''
  formData.append('email',email)
  formData.append('description', desc)

  formData.append('name',name)
  formData.append('product_name',selectVal)
  formData.append('order_id',order)
  if(file) formData.append('file',file)

  maintenance_form_loding('Next', 'loading')
  $.ajax({
    // url: 'https://api.tozo.tech/api/v1/contactform',
    url: 'https://api.tozostore.com/api/v1/contactform',
    type: 'post',
    data:formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    success: function(data) {
      maintenance_form_loding('Next', 'text')
      console.log(data)
      showMessage('success',data.message)
      fileText[0]?.setAttribute("placeholder",'rtf, doc, pdf, zip, rar, png, jpeg, jpg, gif');
      form.reset();
    },
    error: function(xhr, status, error) {
      maintenance_form_loding('Next', 'text')
      showMessage('error', 'Failed to submit warranty data, please try later');
      fileText[0]?.setAttribute("placeholder",'rtf, doc, pdf, zip, rar, png, jpeg, jpg, gif');
      // form.reset();
    }
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__recommend"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    // // 初始化Slick轮播
    $('.recommend-slider').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      asNavFor: '.recommend-for',
      autoplay: true,
      arrows: false,
      autoplaySpeed: 2000,
      centerMode: true,
      infinite: true,
      centerPadding: 0,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            slidesToShow: 3,
            centerPadding: 0
          }
        }
      ]
    });

    $('.recommend-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      infinite: true,
      fade: true,
      asNavFor: '.recommend-slider',
      responsive : [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: 0,
            slidesToShow: 1
          }
        }
      ]
    });

    // 点击轮播图中的图片时滑动到中心位置
    $('.recommend-slider').on('click', '.slick-slide', function() {
      var clickedIndex = $(this).data('slick-index');
      // 确定滑动方向 // 解决负数时滑动没有效果
      if (clickedIndex < -1) {
        let index = $('.recommend-slider').slick('getSlick').slideCount + clickedIndex;
        $('.recommend-slider').slick('slickGoTo', index, true, 3000);
      } else {
        $('.recommend-slider').slick('slickGoTo', clickedIndex);
      }
    });

    // 检测User-Agent
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // 判断是移动端还是PC端
    if (!isMobile) {
      // PC端
      // 鼠标移动到轮播图上时停止自动滑动
      $('.recommend-slider, .recommend-for, .section_recommend').hover(
        function() {
          $('.recommend-slider, .recommend-for').slick('slickPause');
        },
        function() {
          $('.recommend-slider, .recommend-for').slick('slickPlay');
        }
      );
    }

    // 允许左右拖动切换C位的图
    $('.recommend-for').on('mousedown', function(){
      $('.recommend-slider').slick('slickPause');
    }).on('mouseup', function(){
      $('.recommend-slider').slick('slickPlay');
    });

    // 移动端手势点击滑动和禁止
    $('.recommend-slider').on('touchstart', function(){
      $('.recommend-slider').slick('slickPause');
    }).on('touchend', function(){
      $('.recommend-slider').slick('slickPlay');
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__recommend_awards"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    // 初始化轮播函数
    function initCarousel() {
      const isMobile = $(window).width() <= 768;
      
      // 销毁现有轮播实例（如果存在）
      if ($('.awards-slider').hasClass('slick-initialized')) {
        $('.awards-slider').slick('unslick');
      }
      
      if ($('.awards-for').hasClass('slick-initialized')) {
        $('.awards-for').slick('unslick');
      }
      
      // 配置轮播选项
      const sliderOptions = {
        slidesToShow: isMobile ? 3 : 7,
        slidesToScroll: 1,
        asNavFor: '.awards-for',
        autoplay: isMobile, // 仅在移动端自动播放
        arrows: false,
        autoplaySpeed: 2000,
        centerMode: true,
        infinite: true,
        centerPadding: 0,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              slidesToShow: 3,
              centerPadding: 0
            }
          }
        ]
      };
      
      const forOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: isMobile, // 仅在移动端自动播放
        autoplaySpeed: 2000,
        arrows: false,
        infinite: true,
        fade: true,
        asNavFor: '.awards-slider',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: 0,
              slidesToShow: 1
            }
          }
        ]
      };
      
      // 初始化轮播
      $('.awards-slider').slick(sliderOptions);
      $('.awards-for').slick(forOptions);
    }
    
    // 初始加载时初始化轮播
    initCarousel();
    
    // 窗口大小变化时重新初始化轮播
    $(window).on('resize', function() {
      initCarousel();
    });
    
    // 点击轮播图中的图片时滑动到中心位置
    $('.awards-slider').on('click', '.slick-slide', function() {
      var clickedIndex = $(this).data('slick-index');
      // 确定滑动方向 // 解决负数时滑动没有效果
      if (clickedIndex < -1) {
        let index = $('.awards-slider').slick('getSlick').slideCount + clickedIndex;
        $('.awards-slider').slick('slickGoTo', index, true, 3000);
      } else {
        $('.awards-slider').slick('slickGoTo', clickedIndex);
      }
    });
    
    // 检测User-Agent
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // 判断是移动端还是PC端
    if (!isMobile) {
      // PC端
      // 鼠标移动到轮播图上时停止自动滑动
      $('.awards-slider, .awards-for, .section_recommend').hover(
        function() {
          $('.awards-slider, .awards-for').slick('slickPause');
        },
        function() {
          $('.awards-slider, .awards-for').slick('slickPlay');
        }
      );
    }
    
    // 允许左右拖动切换C位的图
    $('.awards-for').on('mousedown', function() {
      $('.awards-slider').slick('slickPause');
    }).on('mouseup', function() {
      $('.awards-slider').slick('slickPlay');
    });
    
    // 移动端手势点击滑动和禁止
    $('.awards-slider').on('touchstart', function() {
      $('.awards-slider').slick('slickPause');
    }).on('touchend', function() {
      $('.awards-slider').slick('slickPlay');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__recommend_icon"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    // // 初始化Slick轮播
    $('.icon-slider').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      asNavFor: '.icon-for',
      autoplay: true,
      arrows: false,
      autoplaySpeed: 2000,
      centerMode: true,
      infinite: true,
      centerPadding: 0,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            slidesToShow: 3,
            centerPadding: 0
          }
        }
      ]
    });

    $('.icon-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      infinite: true,
      fade: true,
      asNavFor: '.icon-slider',
      responsive : [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: 0,
            slidesToShow: 1
          }
        }
      ]
    });

    // 点击轮播图中的图片时滑动到中心位置
    $('.icon-slider').on('click', '.slick-slide', function() {
      var clickedIndex = $(this).data('slick-index');
      // 确定滑动方向 // 解决负数时滑动没有效果
      if (clickedIndex < -1) {
        let index = $('.icon-slider').slick('getSlick').slideCount + clickedIndex;
        $('.icon-slider').slick('slickGoTo', index, true, 3000);
      } else {
        $('.icon-slider').slick('slickGoTo', clickedIndex);
      }
    });

    // 检测User-Agent
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // 判断是移动端还是PC端
    if (!isMobile) {
      // PC端
      // 鼠标移动到轮播图上时停止自动滑动
      $('.icon-slider, .icon-for, .section_recommend').hover(
        function() {
          $('.icon-slider, .icon-for').slick('slickPause');
        },
        function() {
          $('.icon-slider, .icon-for').slick('slickPlay');
        }
      );
    }

    // 允许左右拖动切换C位的图
    $('.icon-for').on('mousedown', function(){
      $('.icon-slider').slick('slickPause');
    }).on('mouseup', function(){
      $('.icon-slider').slick('slickPlay');
    });

    // 移动端手势点击滑动和禁止
    $('.icon-slider').on('touchstart', function(){
      $('.icon-slider').slick('slickPause');
    }).on('touchend', function(){
      $('.icon-slider').slick('slickPlay');
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__recommend_new"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    // // 初始化Slick轮播
    $('.recommend-slider').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      asNavFor: '.recommend-for',
      autoplay: true,
      arrows: false,
      autoplaySpeed: 2000,
      centerMode: true,
      infinite: true,
      centerPadding: 0,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            slidesToShow: 3,
            centerPadding: 0
          }
        }
      ]
    });

    $('.recommend-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      infinite: true,
      fade: true,
      asNavFor: '.recommend-slider',
      responsive : [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: 0,
            slidesToShow: 1
          }
        }
      ]
    });

    // 点击轮播图中的图片时滑动到中心位置
    $('.recommend-slider').on('click', '.slick-slide', function() {
      var clickedIndex = $(this).data('slick-index');
      // 确定滑动方向 // 解决负数时滑动没有效果
      if (clickedIndex < -1) {
        let index = $('.recommend-slider').slick('getSlick').slideCount + clickedIndex;
        $('.recommend-slider').slick('slickGoTo', index, true, 3000);
      } else {
        $('.recommend-slider').slick('slickGoTo', clickedIndex);
      }
    });

    // 检测User-Agent
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // 判断是移动端还是PC端
    if (!isMobile) {
      // PC端
      // 鼠标移动到轮播图上时停止自动滑动
      $('.recommend-slider, .recommend-for, .section_recommend').hover(
        function() {
          $('.recommend-slider, .recommend-for').slick('slickPause');
        },
        function() {
          $('.recommend-slider, .recommend-for').slick('slickPlay');
        }
      );
    }

    // 允许左右拖动切换C位的图
    $('.recommend-for').on('mousedown', function(){
      $('.recommend-slider').slick('slickPause');
    }).on('mouseup', function(){
      $('.recommend-slider').slick('slickPlay');
    });

    // 移动端手势点击滑动和禁止
    $('.recommend-slider').on('touchstart', function(){
      $('.recommend-slider').slick('slickPause');
    }).on('touchend', function(){
      $('.recommend-slider').slick('slickPlay');
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__slideshow-classic-release"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 1. 数字递增动画核心函数（时长改为3000ms = 3秒）
  /**
   * @param {HTMLElement} element - 动画元素
   * @param {number} target - 目标数值
   * @param {number} duration - 动画时长（3000ms）
   */
  function animateNumber(element, target, duration = 3000) {
    // 避免重复执行动画（通过 data-animated 标记）
    if (element.dataset.animated === 'true' || target === 0) {
      element.textContent = target;
      element.dataset.animated = 'true';
      return;
    }

    let start = 0;
    const startTime = performance.now(); // 高精度时间戳

    // 2. 逐帧更新数值
    function updateNumber(currentTime) {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1); // 进度控制在0~1
      const currentValue = Math.floor(progress * target); // 整数显示（如需小数可改 toFixed(1)）
      
      element.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(updateNumber); // 继续下一帧
      } else {
        element.textContent = target; // 确保最终值准确
        element.dataset.animated = 'true'; // 标记动画已完成
      }
    }

    requestAnimationFrame(updateNumber); // 启动动画
  }

  // 3. 监听元素是否滚动到视图中间（核心逻辑）
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // 当元素进入视口中间（threshold: 0.5 表示元素50%可见时触发）
      if (entry.isIntersecting) {
        // 获取两个数字元素
        const num1Element = entry.target.querySelector('.battery_life_num1');
        const num2Element = entry.target.querySelector('.battery_life_num2');

        // 执行动画（从 data-target 取目标值）
        if (num1Element) {
          const target1 = parseInt(num1Element.dataset.target, 10) || 0;
          animateNumber(num1Element, target1);
        }
        if (num2Element) {
          const target2 = parseInt(num2Element.dataset.target, 10) || 0;
          animateNumber(num2Element, target2);
        }

        // 动画触发后，停止监听该元素（避免滚动来回重复执行）
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5, // 触发条件：元素50%进入视口（即视图中间）
    rootMargin: '0px' // 可选：调整触发区域偏移，默认无偏移
  });

  // 4. 开始监听数字所在的容器（battery_life_big_box）
  const animatedContainer = document.querySelector('.battery_life_big_box');
  if (animatedContainer) {
    observer.observe(animatedContainer);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_page_suspension_buy_btn"] && !Shopify.designMode) return;
  try {
    
  function setFooterClassicPaddingBottom(){
    let shopifySectionFooterClassic = document.getElementById('shopify-section-footer-classic')
    if(shopifySectionFooterClassic){
      shopifySectionFooterClassic.style.paddingBottom = "63px"
    }
  }

  //如果有cookie，购买按钮在cookie提示上方
  function set_suspension_buy_sticky() {
    // 1. 获取元素
    const message = document.querySelector('#shopify-section-fixed-message');
    const suspension_buy_btn_section = document.querySelector('.suspension_buy_btn_section');
    if (!message || !suspension_buy_btn_section) return;

    // 绑定关闭按钮点击事件（只绑定一次）
    const closeBtn = message.querySelector('.fixed-message__button');
    if (closeBtn && !closeBtn.dataset.bound) {
      closeBtn.addEventListener('click', () => {
        // 延迟执行，等待DOM动画消失或类名变化
        setTimeout(() => set_suspension_buy_sticky(), 300);
      });
      closeBtn.dataset.bound = 'true';
    }
  
    // 2. 判断 message 是否含有类名 'is-fixed-bottom'
    const isFixedBottom = message.classList.contains('is-fixed-bottom');
    // 3. 计算底部距离
    let bottom = 0;
    if (isFixedBottom) {
      // 获取 message 的高度（包括 padding）
      bottom = message.offsetHeight || 0;
      suspension_buy_btn_section.style.bottom = bottom + 'px';
    } else {
      suspension_buy_btn_section.style.bottom = '0';
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    setFooterClassicPaddingBottom()
    setTimeout(set_suspension_buy_sticky, 200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing_page_banner_aj"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 1. 数字递增动画核心函数（时长改为3000ms = 3秒）
  /**
   * @param {HTMLElement} element - 动画元素
   * @param {number} target - 目标数值
   * @param {number} duration - 动画时长（3000ms）
   */
  function animateNumber(element, target, duration = 3000) {
    // 避免重复执行动画（通过 data-animated 标记）
    if (element.dataset.animated === 'true' || target === 0) {
      element.textContent = target;
      element.dataset.animated = 'true';
      return;
    }

    let start = 0;
    const startTime = performance.now(); // 高精度时间戳

    // 2. 逐帧更新数值
    function updateNumber(currentTime) {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1); // 进度控制在0~1
      const currentValue = Math.floor(progress * target); // 整数显示（如需小数可改 toFixed(1)）
      
      element.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(updateNumber); // 继续下一帧
      } else {
        element.textContent = target; // 确保最终值准确
        element.dataset.animated = 'true'; // 标记动画已完成
      }
    }

    requestAnimationFrame(updateNumber); // 启动动画
  }

  // 3. 监听元素是否滚动到视图中间（核心逻辑）
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // 当元素进入视口中间（threshold: 0.5 表示元素50%可见时触发）
      if (entry.isIntersecting) {
        // 获取两个数字元素
        const num1Element = entry.target.querySelector('.battery_life_num1');
        const num2Element = entry.target.querySelector('.battery_life_num2');

        // 执行动画（从 data-target 取目标值）
        if (num1Element) {
          const target1 = parseInt(num1Element.dataset.target, 10) || 0;
          animateNumber(num1Element, target1);
        }
        if (num2Element) {
          const target2 = parseInt(num2Element.dataset.target, 10) || 0;
          animateNumber(num2Element, target2);
        }

        // 动画触发后，停止监听该元素（避免滚动来回重复执行）
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5, // 触发条件：元素50%进入视口（即视图中间）
    rootMargin: '0px' // 可选：调整触发区域偏移，默认无偏移
  });

  // 4. 开始监听数字所在的容器（battery_life_big_box）
  const animatedContainer = document.querySelector('.battery_life_big_box');
  if (animatedContainer) {
    observer.observe(animatedContainer);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-form"]) return;
  try {
    
    console.log('hello world');
   (function(){
      var reg = new RegExp("(^|&)" + "checkout_url" + "=([^&]*)(&|$)", "i");
       var r = window.location.search.substr(1).match(reg);
       var context = "";
       if (r != null) {
         context = decodeURIComponent(r[2]);
	   }
	    var curUrl = (context == null || context == "" || context == "undefined") ? "" : context;
	    curUrl = (curUrl == "")? "https://13885f.myshopify.com/" : curUrl;
      console.log(curUrl);
      window.location.href = location_url + curUrl;
      // window.location.href = 'https://passport.tozo.tech/login?app=shop-us&redirect_url=' + curUrl;
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logistics"] && !Shopify.designMode) return;
  try {
    
  var api_url = 'https://api.tozostore.com/api/v1/'
  var country_id
  var country_iso_code

  /*const productUpload = document.getElementById('productUpload');*/
  const imgContainer_1 = document.getElementById('imgContainer_1');
  const img_1 = document.getElementById('img_1');
  const icon_1 = document.getElementById('icon_1');
  const img_box_1 = document.getElementById('img_box_1');
  const img_mask1 = document.getElementById('img-mask1');

  const imgContainer_2 = document.getElementById('imgContainer_2');
  const img_2 = document.getElementById('img_2');
  const icon_2 = document.getElementById('icon_2');
  const img_mask2 = document.getElementById('img-mask2');

  const imgContainer_3 = document.getElementById('imgContainer_3');
  const img_3 = document.getElementById('img_3');
  const icon_3 = document.getElementById('icon_3');
  const img_mask3 = document.getElementById('img-mask3');

  const showImg_1 = document.getElementById('showImg_1');
  const delImg_1 = document.getElementById('delImg_1');

  const showImg_2 = document.getElementById('showImg_2');
  const delImg_2 = document.getElementById('delImg_2');

  const showImg_3 = document.getElementById('showImg_3');
  const delImg_3 = document.getElementById('delImg_3');

  const modal = document.getElementById('modal');
  const modalImg = document.getElementById('modalImg');
  const closeIcon = document.getElementById('closeIcon');

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  const Sava_text = document.getElementById('Sava_text');
  const Sava_img = document.getElementById('Sava_img');
  var NextButton = true;
  var SavaButton = true;

  var api_err = document.getElementById('api_err');

  modal.style.width = '0%';
  modal.style.height = '0%';

  let imgUrl_1 = '';
  let imgUrl_2 = '';
  let imgUrl_3 = '';

  let uploadData = {
    id: localStorage.getItem('coop_logistic_id'),
    busi: [],
    comp: [],
    prod: []
  }

  // 点击预览图片1
  showImg_1.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_1;
  }
  // 点击预览图片2
  showImg_2.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_2;
  }
  // 点击预览图片3
  showImg_3.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_3;
  }

  // 关闭 modal 框
  closeIcon.onclick = function (value) {
    modal.style.width = '0';
    modal.style.height = '0';
    modalImg.src = '';
  }

  // 删除上传的图片1
  delImg_1.onclick = function (value) {
    businessUpload.value = '';
    imgUrl_1 = '';
    icon_1.style.display = 'block';
    imgContainer_1.style.display = 'none';
    uploadData.busi = []
  }
  // 删除上传的图片2
  delImg_2.onclick = function (value) {
    companyUpload.value = '';
    imgUrl_2 = '';
    icon_2.style.display = 'block';
    imgContainer_2.style.display = 'none';
    uploadData.comp = []
  }
  // 删除上传的图片3
  delImg_3.onclick = function (value) {
    productUpload.value = '';
    imgUrl_3 = '';
    icon_3.style.display = 'block';
    imgContainer_3.style.display = 'none';
    uploadData.prod = []
  }

  $(document).ready(function() {
    const dropdown = document.querySelector('.dropdown')
    const input__icon_country = document.querySelector('.input__icon_country')
    const input__icon = document.querySelector('.input__icon')
    const dropdownText_country = document.querySelector('#country')
    const dropdownText = document.querySelector('#prefix')
    const dropdownMenu_country = document.querySelector('.dropdown-menu_country')
    const dropdownMenu = document.querySelector('.dropdown-menu')
    const dropdownIcon_country = document.querySelector('.input__icon-arrow_country')
    const dropdownIcon = document.querySelector('.input__icon-arrow')
    const phoneGet = document.querySelector('.phone__get')
    const phoneNumber = document.querySelector('#phone')
    const isacc = document.querySelector('#isacc')
    const businessUpload = document.querySelector('#businessUpload')
    const companyUpload = document.querySelector('#companyUpload')
    const productUpload = document.querySelector('#productUpload')
    const sava_submit = document.querySelector('#Sava_submit')

    const businessUpload_err = document.getElementById('businessUpload_err')
    const companyUpload_err = document.getElementById('companyUpload_err')
    const productUpload_err = document.getElementById('productUpload_err')
    
    input__icon_country.addEventListener('click', function() {
      get_country_list()
    })
    dropdownText_country.addEventListener('click', function() {
      get_country_list()
    })

    input__icon.addEventListener('click', function() {
      get_code_list()
    })
    dropdownText.addEventListener('click', function() {
      get_code_list()
    })
    function get_country_list(){
      if(dropdownMenu_country.style.display == 'none') {
        dropdownMenu_country.style.display = 'block'
        dropdownIcon_country.classList.add('is__reverse')
      }else {
        dropdownMenu_country.style.display = 'none'
        dropdownIcon_country.classList.remove('is__reverse')
      }
    }

    function get_code_list(){
      if(dropdownMenu.style.display == 'none') {
        dropdownMenu.style.display = 'block'
        dropdownIcon.classList.add('is__reverse')
      }else {
        dropdownMenu.style.display = 'none'
        dropdownIcon.classList.remove('is__reverse')
      }
    }

    let flag = true
    phoneGet.addEventListener('click',function() {
      if(!phoneNumber.value){
        error_fun('phone_required', 'error_text')
        return
      }else{
        error_fun('', 'error_text')
      }
      let data = {
        phone: phoneNumber.value,
        prefix: dropdownText.value.slice(1)
      }
      if(flag) {
        flag = false
        $.ajax({
        url: api_url + 'sms',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          if(res.code == 1){
            // form.reset();
            phoneGet.classList.add('cursor_no')
            let time = 60
            let countdownInterval = setInterval(() => {
              if(time <= 0) {
                clearInterval(countdownInterval)
                phoneGet.classList.remove('cursor_no')
                let textContent = get_code_text()
                phoneGet.textContent = textContent ? textContent : 'Get Code'
                time = 60
                flag = true
              } else {
                time--
                phoneGet.textContent = time + 's'
              }
            }, 1000);
          }else{
            flag = true
            error_fun(res, 'error_fun')
          }
        },
        error: function(xhr, status, error) {
          flag = true
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
      }
    })

    function removeClass(elms,targetElm) {
      elms.forEach((item) => {
        item.classList.remove(targetElm)
      })
    }

    $.ajax({
      url: api_url + 'country?lang_id=1',
      type: 'get',
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function(res) {
        console.log(res)
        if(res.code == 1){
          // form.reset();
          let data = res.data
          dropdownText.value = `+${data[0].call_prefix}`
          dropdownText_country.value = `${data[0].name}`
          for (let i = 0; i < data.length; i++) {
            const li = document.createElement("li")
            li.innerHTML =  `
              <span class="ls-select__option-prefix">+${data[i].call_prefix}</span>
              <span class="ls-select__option-code">${data[i].iso_code}</span>
            `
            if(i === 0) {
              li.classList.add('select_li')
            }
            li.addEventListener('click', function() {
              dropdownText.value = `+${data[i].call_prefix}`
              dropdownMenu.style.display = 'none'
              dropdownIcon.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu >li')
              removeClass(prefixs,'select_li')
              li.classList.add('select_li')
            })
            dropdownMenu.appendChild(li)


            const div = document.createElement("div")
            div.innerHTML = `<span class="ls-select__option-prefix">${data[i].name}</span>`
            if(i === 0) {
              div.classList.add('select_li')
            }
            div.addEventListener('click', function() {
              dropdownText.value = `+${data[i].call_prefix}`
              country_id = `${data[i].id}`
              country_iso_code = `${data[i].iso_code}`

              dropdownText_country.value = `${data[i].name}`
              dropdownMenu_country.style.display = 'none'
              dropdownIcon_country.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu_country > div')
              removeClass(prefixs,'select_li')
              div.classList.add('select_li')
            })
            dropdownMenu_country.appendChild(div)
          }
          }else{
            error_fun(res, 'error_fun')
          }
      },
      error: function(xhr, status, error) {
        error_fun(error, 'error_fun')
        // form.reset();
      }
    })

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
      
      if(button == 'Sava'){
        if(type == 'text'){
          SavaButton = true
          Sava_text.style.display = 'block'
          Sava_img.style.display = 'none'
        }else{
          SavaButton = false
          Sava_text.style.display = 'none'
          Sava_img.style.display = 'block'
        }
      }
    }

    function showMessage(type, message, duration = 3000) {
      // const messageBox = document.getElementById('message');
      // messageBox.style.transform = 'translate(-50%,0)'
      // const html = `<span>${message}</span>`;
      // messageBox.innerHTML = html;
      // messageBox.classList.add(type, 'show');
      // setTimeout(() => {
      // messageBox.classList.remove(type,'show');
      // messageBox.style.transform = 'translate(-50%, 50px)'
      // }, duration);
    }

    businessUpload.addEventListener('change',function(value) {
      get_coop_logistic_id(1, businessUpload)
    })

    companyUpload.addEventListener('change',function(value) {
      get_coop_logistic_id(2, companyUpload)
    })

    productUpload.addEventListener('change',function(value) {
      /*const fileList = value.target.files;*/
      get_coop_logistic_id(3, productUpload)
    })

    function get_coop_logistic_id(num, Upload){
      let coop_logistic_id = localStorage.getItem('coop_logistic_id')
      if(!coop_logistic_id || coop_logistic_id == null) {
        img_fun_err(0, "js_image_required")
        // img_fun_err(0, 'Please fill in your information first and upload the image here')
        // showMessage('error', 'Please complete the first step')
        return
      }
      get_imgList(num, Upload)
      // post_img_pai(num, Upload) 
    }

    function get_imgList(type, Upload_list){
      const fileList = Upload_list.files
      let file_type = fileList[0].type
      if (fileList.length) {
        const index = file_type.lastIndexOf("/");
        const pathType = file_type.slice(index + 1, file_type.length);
        console.log(pathType)
        // if(fileList[0].type == "application/pdf"){
        //   // get_pdfList(type, fileList)
        //   // img_box_1.style.display = 'none'
        // }else 
        if(fileList[0].size > 1024 * 1024 * 3){
          console.log('文件总大小不能超过3M')
          img_fun_err(type, "js_image_file_max")
          // img_fun_err(type, 'The total file size cannot exceed 3M')
        }else if(pathType == "jpg" || pathType == "jpeg" || pathType == "png" || pathType == "bmp"){
          post_img_pai(type, Upload_list) 
          let gif_url = 'https://cdn.shopifycdn.net/s/files/1/0737/0578/3585/files/98288-loading.gif?v=1686638388'
          if(type == 1){
            imgContainer_1.style.display = 'block';
            icon_1.style.display = 'none';
            img_mask1.style.display = 'none';
            img_1.src = gif_url;
          }else if(type == 2){
            imgContainer_2.style.display = 'block';
            icon_2.style.display = 'none';
            img_mask2.style.display = 'none';
            img_2.src = gif_url;
          }else if(type == 3){
            imgContainer_3.style.display = 'block';
            icon_3.style.display = 'none';
            img_mask3.style.display = 'none';
            img_3.src = gif_url;
          }
          // if(type == 1){
          //   imgContainer_1.style.display = 'block';
          //   icon_1.style.display = 'none';
          //   imgUrl_1 = window.URL.createObjectURL(fileList[0]);
          //   img_1.src = imgUrl_1;
          //   console.log(imgUrl_1)
          //   console.log(img_1)
          //   img_fun_err(type, '')
          // }else if(type == 2){
          //   imgContainer_2.style.display = 'block';
          //   icon_2.style.display = 'none';
          //   imgUrl_2 = window.URL.createObjectURL(fileList[0]);
          //   img_2.src = imgUrl_2;
          //   console.log(imgUrl_2)
          //   console.log(img_2)
          //   img_fun_err(type, '')
          // }else if(type == 3){
          //   imgContainer_3.style.display = 'block';
          //   icon_3.style.display = 'none';
          //   imgUrl_3 = window.URL.createObjectURL(fileList[0]);
          //   img_3.src = imgUrl_3;
          //   console.log(imgUrl_3)
          //   console.log(img_3)
          //   img_fun_err(type, '')
          // }
        }else{
          console.log('文件类型不支持')
          img_fun_err(type, "js_image_file_type")
          // img_fun_err(type, 'File type not supported')
        }
      }
    }

    function get_pdfList(type, fileList){
      const file = fileList;
      const fileReader = new FileReader();
      console.log(fileReader)
      fileReader.onload = function() {
        const typedArray = new Uint8Array(this.result);
        PDFJS.getDocument(typedArray).then(function(pdf) {
          pdf.getPage(1).then(function(page) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const viewport = page.getViewport({ scale: 1 });
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            page.render({ canvasContext: context, viewport: viewport }).promise.then(function() {
              pdfViewer.appendChild(canvas);
            });
          });
        });
      };
      console.log(fileReader)
      fileReader.readAsArrayBuffer(file);
    }

    function post_img_pai(type, Upload_type){
      let coop_logistic_id = localStorage.getItem('coop_logistic_id')
      console.log(coop_logistic_id)
      if(!coop_logistic_id || coop_logistic_id == null) {
        error_fun('js_complete_first_step', 'error_text')
        // showMessage('error', 'Please complete the first step')
        // api_err.innerHTML = 'Please complete the first step'
        return 
      }
      const formData = new FormData()
      formData.append('coop_logistic_id', coop_logistic_id)
      formData.append('type', type)
      formData.append('file', Upload_type.files[0])
      // 打印参数
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      if(Upload_type.files.length > 0) {
          $.ajax({
            url: api_url + 'coop/logistic/file',
            type: 'post',
            data:formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function(res) {
              if(res.code == 1){
                const fileList = Upload_type.files
                if(type == 1){
                  uploadData.busi.push(res.data.id)
                  imgContainer_1.style.display = 'block';
                  icon_1.style.display = 'none';
                  img_mask1.style.display = 'block';
                  imgUrl_1 = window.URL.createObjectURL(fileList[0]);
                  img_1.src = imgUrl_1;
                  img_fun_err(type, '')
                }else if(type == 2){
                  uploadData.comp.push(res.data.id)
                  imgContainer_2.style.display = 'block';
                  icon_2.style.display = 'none';
                  img_mask2.style.display = 'block';
                  imgUrl_2 = window.URL.createObjectURL(fileList[0]);
                  img_2.src = imgUrl_2;
                  img_fun_err(type, '')
                }else if(type == 3){
                  uploadData.prod.push(res.data.id)
                  imgContainer_3.style.display = 'block';
                  icon_3.style.display = 'none';
                  img_mask3.style.display = 'block';
                  imgUrl_3 = window.URL.createObjectURL(fileList[0]);
                  img_3.src = imgUrl_3;
                  img_fun_err(type, '')
                }
                // if(type == 1){
                //   uploadData.busi.push(res.data.id)
                // }else if(type == 2){
                //   uploadData.comp.push(res.data.id)
                // }else if(type == 3){
                //   uploadData.prod.push(res.data.id)
                // }
              }else{
                error_fun(res, 'error_fun')
              }
            },
            error: function(xhr, status, error) {
              form_loding('Sava', 'text')
              error_fun(error, 'error_fun')
              // form.reset();
            }
          })
      }
    }

    $('#suppiler-form1')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this)
      let prefix = dropdownText.value.slice(1)
      let isaccValue = isacc.checked
      formData.set('prefix', prefix)
      formData.set('isacc', isaccValue)

      // 打印参数
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'coop/logistic',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 1){
            click_set_fun(2)
            localStorage.setItem('coop_logistic_id', res.data.id)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

    sava_submit.addEventListener('click', function(event) {
      event.preventDefault();
      console.log(uploadData.busi)
      console.log(uploadData.comp)
      console.log(uploadData.prod)
      if(uploadData.busi.length == 0){
        return img_fun_err(1, "js_image_business_license")
        // return img_fun_err(1, 'Please upload a picture of your business license')
      }else if(uploadData.comp.length == 0){
        return img_fun_err(2, "js_image_qualification_image")
        // return img_fun_err(2, 'Please upload a company qualification image')
      }else if(uploadData.prod.length == 0){
        return img_fun_err(3, "js_image_manual_images")
        // return img_fun_err(3, 'Please upload product manual images')
      }else{
        img_fun_err(0, '')
      }
      put_manufacturer()
    })
    
    function put_manufacturer(){
      console.log(SavaButton)
      if(!SavaButton){ return }
      form_loding('Sava', 'img')
      api_err.innerHTML = ''
      uploadData.id = localStorage.getItem('coop_logistic_id')
      $.ajax({
        url: api_url + 'coop/logistic',
        type: 'put',
        data: uploadData,
        success: function(res) {
          console.log(uploadData)
          form_loding('Sava', 'text')
          if(res.code == 1){
            click_set_fun(3)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplier"] && !Shopify.designMode) return;
  try {
    
  var api_url = 'https://api.tozostore.com/api/v1/'
  var country_id
  var country_iso_code

  /*const productUpload = document.getElementById('productUpload');*/
  const imgContainer_1 = document.getElementById('imgContainer_1');
  const img_1 = document.getElementById('img_1');
  const icon_1 = document.getElementById('icon_1');
  const img_box_1 = document.getElementById('img_box_1');
  const img_mask1 = document.getElementById('img-mask1');

  const imgContainer_2 = document.getElementById('imgContainer_2');
  const img_2 = document.getElementById('img_2');
  const icon_2 = document.getElementById('icon_2');
  const img_mask2 = document.getElementById('img-mask2');

  const imgContainer_3 = document.getElementById('imgContainer_3');
  const img_3 = document.getElementById('img_3');
  const icon_3 = document.getElementById('icon_3');
  const img_mask3 = document.getElementById('img-mask3');

  const showImg_1 = document.getElementById('showImg_1');
  const delImg_1 = document.getElementById('delImg_1');

  const showImg_2 = document.getElementById('showImg_2');
  const delImg_2 = document.getElementById('delImg_2');

  const showImg_3 = document.getElementById('showImg_3');
  const delImg_3 = document.getElementById('delImg_3');

  const modal = document.getElementById('modal');
  const modalImg = document.getElementById('modalImg');
  const closeIcon = document.getElementById('closeIcon');

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  const Sava_text = document.getElementById('Sava_text');
  const Sava_img = document.getElementById('Sava_img');
  var NextButton = true;
  var SavaButton = true;

  var api_err = document.getElementById('api_err');

  modal.style.width = '0%';
  modal.style.height = '0%';

  let imgUrl_1 = '';
  let imgUrl_2 = '';
  let imgUrl_3 = '';

  let uploadData = {
    id: localStorage.getItem('coop_manufacturer_id'),
    busi: [],
    comp: [],
    prod: []
  }

  // 点击预览图片1
  showImg_1.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_1;
  }
  // 点击预览图片2
  showImg_2.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_2;
  }
  // 点击预览图片3
  showImg_3.onclick = function (value) {
    modal.style.width = '100%';
    modal.style.height = '100%';
    modalImg.src = imgUrl_3;
  }

  // 关闭 modal 框
  closeIcon.onclick = function (value) {
    modal.style.width = '0';
    modal.style.height = '0';
    modalImg.src = '';
  }

  // 删除上传的图片1
  delImg_1.onclick = function (value) {
    businessUpload.value = '';
    imgUrl_1 = '';
    icon_1.style.display = 'block';
    imgContainer_1.style.display = 'none';
    uploadData.busi = []
  }
  // 删除上传的图片2
  delImg_2.onclick = function (value) {
    companyUpload.value = '';
    imgUrl_2 = '';
    icon_2.style.display = 'block';
    imgContainer_2.style.display = 'none';
    uploadData.comp = []
  }
  // 删除上传的图片3
  delImg_3.onclick = function (value) {
    productUpload.value = '';
    imgUrl_3 = '';
    icon_3.style.display = 'block';
    imgContainer_3.style.display = 'none';
    uploadData.prod = []
  }

  $(document).ready(function() {
    const dropdown = document.querySelector('.dropdown')
    const input__icon_country = document.querySelector('.input__icon_country')
    const input__icon = document.querySelector('.input__icon')
    const dropdownText_country = document.querySelector('#country')
    const dropdownText = document.querySelector('#prefix')
    const dropdownMenu_country = document.querySelector('.dropdown-menu_country')
    const dropdownMenu = document.querySelector('.dropdown-menu')
    const dropdownIcon_country = document.querySelector('.input__icon-arrow_country')
    const dropdownIcon = document.querySelector('.input__icon-arrow')
    const phoneGet = document.querySelector('.phone__get')
    const phoneNumber = document.querySelector('#phone')
    const isacc = document.querySelector('#isacc')
    const businessUpload = document.querySelector('#businessUpload')
    const companyUpload = document.querySelector('#companyUpload')
    const productUpload = document.querySelector('#productUpload')
    const sava_submit = document.querySelector('#Sava_submit')

    const businessUpload_err = document.getElementById('businessUpload_err')
    const companyUpload_err = document.getElementById('companyUpload_err')
    const productUpload_err = document.getElementById('productUpload_err')
    
    input__icon_country.addEventListener('click', function() {
      get_country_list()
    })
    dropdownText_country.addEventListener('click', function() {
      get_country_list()
    })

    input__icon.addEventListener('click', function() {
      get_code_list()
    })
    dropdownText.addEventListener('click', function() {
      get_code_list()
    })
    function get_country_list(){
      if(dropdownMenu_country.style.display == 'none') {
        dropdownMenu_country.style.display = 'block'
        dropdownIcon_country.classList.add('is__reverse')
      }else {
        dropdownMenu_country.style.display = 'none'
        dropdownIcon_country.classList.remove('is__reverse')
      }
    }

    function get_code_list(){
      if(dropdownMenu.style.display == 'none') {
        dropdownMenu.style.display = 'block'
        dropdownIcon.classList.add('is__reverse')
      }else {
        dropdownMenu.style.display = 'none'
        dropdownIcon.classList.remove('is__reverse')
      }
    }

    let flag = true
    phoneGet.addEventListener('click',function() {
      if(!phoneNumber.value){
        error_fun('phone_required', 'error_text')
        return
      }else{
        error_fun('', 'error_text')
      }
      let data = {
        phone: phoneNumber.value,
        prefix: dropdownText.value.slice(1)
      }
      if(flag) {
        flag = false
        $.ajax({
        url: api_url + 'sms',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          if(res.code == 1){
            // form.reset();
            phoneGet.classList.add('cursor_no')
            let time = 60
            let countdownInterval = setInterval(() => {
              if(time <= 0) {
                clearInterval(countdownInterval)
                phoneGet.classList.remove('cursor_no')
                let textContent = get_code_text()
                phoneGet.textContent = textContent ? textContent : 'Get Code'
                time = 60
                flag = true
              } else {
                time--
                phoneGet.textContent = time + 's'
              }
            }, 1000);
          }else{
            flag = true
            error_fun(res, 'error_fun')
          }
        },
        error: function(xhr, status, error) {
          flag = true
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
      }
    })

    function removeClass(elms,targetElm) {
      elms.forEach((item) => {
        item.classList.remove(targetElm)
      })
    }

    $.ajax({
      url: api_url + 'country?lang_id=1',
      type: 'get',
      processData: false,
      contentType: false,
      dataType: 'json',
      success: function(res) {
        console.log(res)
        if(res.code == 1){
          // form.reset();
          let data = res.data
          dropdownText.value = `+${data[0].call_prefix}`
          dropdownText_country.value = `${data[0].name}`
          for (let i = 0; i < data.length; i++) {
            const li = document.createElement("li")
            li.innerHTML =  `
              <span class="ls-select__option-prefix">+${data[i].call_prefix}</span>
              <span class="ls-select__option-code">${data[i].iso_code}</span>
            `
            if(i === 0) {
              li.classList.add('select_li')
            }
            li.addEventListener('click', function() {
              dropdownText.value = `+${data[i].call_prefix}`
              dropdownMenu.style.display = 'none'
              dropdownIcon.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu >li')
              removeClass(prefixs,'select_li')
              li.classList.add('select_li')
            })
            dropdownMenu.appendChild(li)


            const div = document.createElement("div")
            div.innerHTML = `<span class="ls-select__option-prefix">${data[i].name}</span>`
            if(i === 0) {
              div.classList.add('select_li')
            }
            div.addEventListener('click', function() {
              dropdownText.value = `+${data[i].call_prefix}`
              country_id = `${data[i].id}`
              country_iso_code = `${data[i].iso_code}`

              dropdownText_country.value = `${data[i].name}`
              dropdownMenu_country.style.display = 'none'
              dropdownIcon_country.classList.remove('is__reverse')
              const prefixs = document.querySelectorAll('.dropdown-menu_country > div')
              removeClass(prefixs,'select_li')
              div.classList.add('select_li')
            })
            dropdownMenu_country.appendChild(div)
          }
          }else{
            error_fun(res, 'error_fun')
          }
      },
      error: function(xhr, status, error) {
        error_fun(error, 'error_fun')
        // form.reset();
      }
    })

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
      
      if(button == 'Sava'){
        if(type == 'text'){
          SavaButton = true
          Sava_text.style.display = 'block'
          Sava_img.style.display = 'none'
        }else{
          SavaButton = false
          Sava_text.style.display = 'none'
          Sava_img.style.display = 'block'
        }
      }
    }

    function showMessage(type, message, duration = 3000) {
      // const messageBox = document.getElementById('message');
      // messageBox.style.transform = 'translate(-50%,0)'
      // const html = `<span>${message}</span>`;
      // messageBox.innerHTML = html;
      // messageBox.classList.add(type, 'show');
      // setTimeout(() => {
      // messageBox.classList.remove(type,'show');
      // messageBox.style.transform = 'translate(-50%, 50px)'
      // }, duration);
    }

    businessUpload.addEventListener('change',function(value) {
      get_coop_manufacturer_id(1, businessUpload)
    })

    companyUpload.addEventListener('change',function(value) {
      get_coop_manufacturer_id(2, companyUpload)
    })

    productUpload.addEventListener('change',function(value) {
      /*const fileList = value.target.files;*/
      get_coop_manufacturer_id(3, productUpload)
    })

    function get_coop_manufacturer_id(num, Upload){
      let coop_manufacturer_id = localStorage.getItem('coop_manufacturer_id')
      if(!coop_manufacturer_id || coop_manufacturer_id == null) {
        img_fun_err(0, "js_image_required")
        // showMessage('error', 'Please complete the first step')
        return
      }
      get_imgList(num, Upload)
      // post_img_pai(num, Upload) 
    }

    function get_imgList(type, Upload_list){
      const fileList = Upload_list.files
      let file_type = fileList[0].type
      if (fileList.length) {
        const index = file_type.lastIndexOf("/");
        const pathType = file_type.slice(index + 1, file_type.length);
        console.log(pathType)
        // if(fileList[0].type == "application/pdf"){
        //   // get_pdfList(type, fileList)
        //   // img_box_1.style.display = 'none'
        // }else 
        if(fileList[0].size > 1024 * 1024 * 3){
          console.log('文件总大小不能超过3M')
          img_fun_err(type, "js_image_file_max")
        }else if(pathType == "jpg" || pathType == "jpeg" || pathType == "png" || pathType == "bmp"){
          post_img_pai(type, Upload_list) 
          let gif_url = 'https://cdn.shopifycdn.net/s/files/1/0737/0578/3585/files/98288-loading.gif?v=1686638388'
          if(type == 1){
            imgContainer_1.style.display = 'block';
            icon_1.style.display = 'none';
            img_mask1.style.display = 'none';
            img_1.src = gif_url;
          }else if(type == 2){
            imgContainer_2.style.display = 'block';
            icon_2.style.display = 'none';
            img_mask2.style.display = 'none';
            img_2.src = gif_url;
          }else if(type == 3){
            imgContainer_3.style.display = 'block';
            icon_3.style.display = 'none';
            img_mask3.style.display = 'none';
            img_3.src = gif_url;
          }
          // if(type == 1){
          //   imgContainer_1.style.display = 'block';
          //   icon_1.style.display = 'none';
          //   imgUrl_1 = window.URL.createObjectURL(fileList[0]);
          //   img_1.src = imgUrl_1;
          //   console.log(imgUrl_1)
          //   console.log(img_1)
          //   img_fun_err(type, '')
          // }else if(type == 2){
          //   imgContainer_2.style.display = 'block';
          //   icon_2.style.display = 'none';
          //   imgUrl_2 = window.URL.createObjectURL(fileList[0]);
          //   img_2.src = imgUrl_2;
          //   console.log(imgUrl_2)
          //   console.log(img_2)
          //   img_fun_err(type, '')
          // }else if(type == 3){
          //   imgContainer_3.style.display = 'block';
          //   icon_3.style.display = 'none';
          //   imgUrl_3 = window.URL.createObjectURL(fileList[0]);
          //   img_3.src = imgUrl_3;
          //   console.log(imgUrl_3)
          //   console.log(img_3)
          //   img_fun_err(type, '')
          // }
        }else{
          console.log('文件类型不支持')
          img_fun_err(type, "js_image_file_type")
        }
      }
    }

    function get_pdfList(type, fileList){
      const file = fileList;
      const fileReader = new FileReader();
      console.log(fileReader)
      fileReader.onload = function() {
        const typedArray = new Uint8Array(this.result);
        PDFJS.getDocument(typedArray).then(function(pdf) {
          pdf.getPage(1).then(function(page) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const viewport = page.getViewport({ scale: 1 });
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            page.render({ canvasContext: context, viewport: viewport }).promise.then(function() {
              pdfViewer.appendChild(canvas);
            });
          });
        });
      };
      console.log(fileReader)
      fileReader.readAsArrayBuffer(file);
    }

    function post_img_pai(type, Upload_type){
      let coop_manufacturer_id = localStorage.getItem('coop_manufacturer_id')
      console.log(coop_manufacturer_id)
      if(!coop_manufacturer_id || coop_manufacturer_id == null) {
        // showMessage('error', 'Please complete the first step')
        api_err.innerHTML = 'Please complete the first step'
        return 
      }
      const formData = new FormData()
      formData.append('coop_manufacturer_id', coop_manufacturer_id)
      formData.append('type', type)
      formData.append('file', Upload_type.files[0])
      // 打印参数
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      if(Upload_type.files.length > 0) {
          $.ajax({
            url: api_url + 'coop/manufacturer/file',
            type: 'post',
            data:formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function(res) {
              if(res.code == 1){
                const fileList = Upload_type.files
                if(type == 1){
                  uploadData.busi.push(res.data.id)
                  imgContainer_1.style.display = 'block';
                  icon_1.style.display = 'none';
                  img_mask1.style.display = 'block';
                  imgUrl_1 = window.URL.createObjectURL(fileList[0]);
                  img_1.src = imgUrl_1;
                  img_fun_err(type, '')
                }else if(type == 2){
                  uploadData.comp.push(res.data.id)
                  imgContainer_2.style.display = 'block';
                  icon_2.style.display = 'none';
                  img_mask2.style.display = 'block';
                  imgUrl_2 = window.URL.createObjectURL(fileList[0]);
                  img_2.src = imgUrl_2;
                  img_fun_err(type, '')
                }else if(type == 3){
                  uploadData.prod.push(res.data.id)
                  imgContainer_3.style.display = 'block';
                  icon_3.style.display = 'none';
                  img_mask3.style.display = 'block';
                  imgUrl_3 = window.URL.createObjectURL(fileList[0]);
                  img_3.src = imgUrl_3;
                  img_fun_err(type, '')
                }
                // if(type == 1){
                //   uploadData.busi.push(res.data.id)
                // }else if(type == 2){
                //   uploadData.comp.push(res.data.id)
                // }else if(type == 3){
                //   uploadData.prod.push(res.data.id)
                // }
              }else{
                error_fun(res, 'error_fun')
              }
            },
            error: function(xhr, status, error) {
              form_loding('Sava', 'text')
              error_fun(error, 'error_fun')
              // form.reset();
            }
          })
      }
    }

    $('#suppiler-form1')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this)
      let prefix = dropdownText.value.slice(1)
      let isaccValue = isacc.checked
      formData.set('prefix', prefix)
      formData.set('isacc', isaccValue)

      // 打印参数
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'coop/manufacturer',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 1){
            click_set_fun(2)
            localStorage.setItem('coop_manufacturer_id', res.data.id)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

    sava_submit.addEventListener('click', function(event) {
      event.preventDefault();
      console.log(uploadData.busi)
      console.log(uploadData.comp)
      console.log(uploadData.prod)
      if(uploadData.busi.length == 0){
        return img_fun_err(1, "js_image_business_license")
      }else if(uploadData.comp.length == 0){
        return img_fun_err(2, "js_image_qualification_image")
      }else if(uploadData.prod.length == 0){
        return img_fun_err(3, "js_image_manual_images")
      }else{
        img_fun_err(0, '')
      }
      put_manufacturer()
    })
    
    function put_manufacturer(){
      console.log(SavaButton)
      if(!SavaButton){ return }
      form_loding('Sava', 'img')
      api_err.innerHTML = ''
      uploadData.id = localStorage.getItem('coop_manufacturer_id')
      $.ajax({
        url: api_url + 'coop/manufacturer',
        type: 'put',
        data: uploadData,
        success: function(res) {
          console.log(uploadData)
          form_loding('Sava', 'text')
          if(res.code == 1){
            click_set_fun(3)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    }
});


  } catch(e) { console.error(e); }
})();
})();
